//import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        '@font-face': {
            fontFamily: "'swiper-icons'",
            src: "url('data:application/font-woff;charset=utf-8;base64, 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')",
            fontWeight: 400,
            fontStyle: 'normal',
        },
        ':root': {'--swiper-theme-color': '#007aff'},
        ':host': {
            position: 'relative',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            zIndex: 1,
        },
        '.swiper': {
            marginLeft: 'auto',
            marginRight: 'auto',
            position: 'relative',
            overflow: 'hidden',
            listStyle: 'none',
            padding: '0',
            zIndex: 1,
            display: 'block',
        },
        '.swiper-vertical > .swiper-wrapper': {flexDirection: 'column'},
        '.swiper-wrapper': {
            position: 'relative',
            width: '100%',
            height: '100%',
            zIndex: 1,
            display: 'flex',
            transitionProperty: 'transform',
            transitionTimingFunction: 'var(--swiper-wrapper-transition-timing-function, initial)',
            boxSizing: 'content-box',
        },
        '.swiper-android .swiper-slide,\n.swiper-ios .swiper-slide,\n.swiper-wrapper': {
            transform: 'translate3d(0px, 0, 0)',
        },
        '.swiper-horizontal': {touchAction: 'pan-y'},
        '.swiper-vertical': {touchAction: 'pan-x'},
        '.swiper-slide': {
            flexShrink: 0,
            width: '100%',
            height: '100%',
            position: 'relative',
            transitionProperty: 'transform',
            display: 'block',
        },
        '.promo-slider-swiper .swiper-slide': {
            '@media (max-width: 1023px)': {
                width: '472px !important',
                flexShrink: 0,
            },
            '@media (max-width: 767px)': {
                width: '285px !important',
                flexShrink: 0,
            },
        },
        '.swiper-slide-invisible-blank': {visibility: 'hidden'},
        '.swiper-autoheight,\n.swiper-autoheight .swiper-slide': {height: 'auto'},
        '.swiper-autoheight .swiper-wrapper': {
            alignItems: 'flex-start',
            transitionProperty: 'transform, height',
        },
        '.swiper-backface-hidden .swiper-slide': {
            transform: 'translateZ(0)',
            WebkitBackfaceVisibility: 'hidden',
            backfaceVisibility: 'hidden',
        },
        '.swiper-3d.swiper-css-mode .swiper-wrapper': {perspective: '1200px'},
        '.swiper-3d .swiper-wrapper': {transformStyle: 'preserve-3d'},
        '.swiper-3d': {perspective: '1200px'},
        '.swiper-3d .swiper-slide,\n.swiper-3d .swiper-cube-shadow': {
            transformStyle: 'preserve-3d',
        },
        '.swiper-css-mode > .swiper-wrapper': {
            overflow: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
        },
        '.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar': {display: 'none'},
        '.swiper-css-mode > .swiper-wrapper > .swiper-slide': {
            scrollSnapAlign: 'start start',
        },
        '.swiper-css-mode.swiper-horizontal > .swiper-wrapper': {
            scrollSnapType: 'x mandatory',
        },
        '.swiper-css-mode.swiper-vertical > .swiper-wrapper': {
            scrollSnapType: 'y mandatory',
        },
        '.swiper-css-mode.swiper-free-mode > .swiper-wrapper': {
            scrollSnapType: 'none',
        },
        '.swiper-css-mode.swiper-free-mode > .swiper-wrapper > .swiper-slide': {
            scrollSnapAlign: 'none',
        },
        '.swiper-css-mode.swiper-centered > .swiper-wrapper::before': {
            content: "''",
            flexShrink: 0,
            order: 9999,
        },
        '.swiper-css-mode.swiper-centered > .swiper-wrapper > .swiper-slide': {
            scrollSnapAlign: 'center center',
            scrollSnapStop: 'always',
        },
        '.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-of-type':
            {
                marginInlineStart: 'var(--swiper-centered-offset-before)',
            },
        '.swiper-css-mode.swiper-centered.swiper-horizontal > .swiper-wrapper::before': {
            height: '100%',
            minHeight: '1px',
            width: 'var(--swiper-centered-offset-after)',
        },
        '.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-oftype':
            {
                marginBlockStart: 'var(--swiper-centered-offset-before)',
            },
        '.swiper-css-mode.swiper-centered.swiper-vertical > .swiper-wrapper::before': {
            width: '100%',
            minWidth: '1px',
            height: 'var(--swiper-centered-offset-after)',
        },
        '.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom,\n.swiper-3d .swiper-slide-shadow,\n.swiper-3d .swiper-slide-shadow-left,\n.swiper-3d .swiper-slide-shadow-right,\n.swiper-3d .swiper-slide-shadow-top,\n.swiper-3d .swiper-slide-shadow-bottom':
            {
                position: 'absolute',
                left: '0',
                top: '0',
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 10,
            },
        '.swiper-3d .swiper-slide-shadow': {background: 'rgba(0, 0, 0, 0.15)'},
        '.swiper-3d .swiper-slide-shadow-left': {
            backgroundImage: 'linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))',
        },
        '.swiper-3d .swiper-slide-shadow-right': {
            backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))',
        },
        '.swiper-3d .swiper-slide-shadow-top': {
            backgroundImage: 'linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))',
        },
        '.swiper-3d .swiper-slide-shadow-bottom': {
            backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))',
        },
        '.swiper-lazy-preloader': {
            width: '42px',
            height: '42px',
            position: 'absolute',
            left: '50%',
            top: '50%',
            marginLeft: '-21px',
            marginTop: '-21px',
            zIndex: 10,
            transformOrigin: '50%',
            boxSizing: 'border-box',
            border: '4px solid var(--swiper-preloader-color, var(--swiper-theme-color))',
            borderRadius: '50%',
            borderTopColor: 'transparent',
        },
        '.swiper:not(.swiper-watch-progress) .swiper-lazy-preloader,\n.swiper-watch-progress .swiper-slide-visible .swiper-lazy-preloader':
            {
                animation: 'swiper-preloader-spin 1s infinite linear',
            },
        '.swiper-lazy-preloader-white': {'--swiper-preloader-color': '#fff'},
        '.swiper-lazy-preloader-black': {'--swiper-preloader-color': '#000'},
        '@keyframes swiper-preloader-spin': {
            '0%': {transform: 'rotate(0deg)'},
            '100%': {transform: 'rotate(360deg)'},
        },
        // '.key-features-slider .swiper-slide-active': {
        //     '@media (max-width: 768px)': {
        //         marginRight: `${remCalc(24)} !important`,
        //     },
        // },
        //* Swiper Pagination
        '--swiper-pagination-color': 'black',
        '--swiper-pagination-left': 'auto',
        '--swiper-pagination-right': '8px',
        '--swiper-pagination-bottom': '0px',
        '--swiper-pagination-top': 'auto',
        '--swiper-pagination-fraction-color': 'inherit',
        '--swiper-pagination-progressbar-bg-color': 'blue',
        '--swiper-pagination-progressbar-size': '4px',
        '--swiper-pagination-bullet-size': '10px',
        '--swiper-pagination-bullet-width': '10px',
        '--swiper-pagination-bullet-height': '10px',
        '--swiper-pagination-bullet-border-radius': '50%',
        '--swiper-pagination-bullet-inactive-color': '#000',
        '--swiper-pagination-bullet-inactive-opacity': '0.2',
        '--swiper-pagination-bullet-opacity': '1',
        '--swiper-pagination-bullet-horizontal-gap': '8px',
        '--swiper-pagination-bullet-vertical-gap': '6px',
        '.befit-icons-swiper': {
            height: '130px',
        },
        '.swiper-pagination': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            textAlign: 'center',
            transition: '300ms opacity',
            transform: 'translate3d(0, 0, 0)',
            zIndex: 10,
        },
        '.promo-slider-pagination': {
            position: 'relative',
            paddingTop: '34px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '.swiper-pagination.swiper-pagination-hidden': {
            opacity: 0,
        },
        '.swiper-pagination-disabled > .swiper-pagination, .swiper-pagination.swiper-pagination-disabled':
            {
                display: 'none !important',
            },
        /* Common Styles */
        '.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-horizontal > .swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal':
            {
                bottom: 'var(--swiper-pagination-bottom, 8px)',
                top: 'var(--swiper-pagination-top, auto)',
                left: 0,
                width: '100%',
            },
        /* Bullets */
        '.swiper-pagination-bullets-dynamic': {
            overflow: 'hidden',
            fontSize: 0,
        },
        '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet': {
            transform: 'scale(0.33)',
            position: 'relative',
        },
        '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active': {
            transform: 'scale(1)',
        },
        '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main': {
            transform: 'scale(1)',
        },
        '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev': {
            transform: 'scale(0.66)',
        },
        '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev': {
            transform: 'scale(0.33)',
        },
        '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next': {
            transform: 'scale(0.66)',
        },
        '.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next': {
            transform: 'scale(0.33)',
        },
        '.swiper-pagination-bullet': {
            width: '8px',
            height: '8px',
            display: 'inline-block',
            borderRadius: 'var(--swiper-pagination-bullet-border-radius, 50%)',
            background: '#636363',
        },
        'button.swiper-pagination-bullet': {
            border: 'none',
            margin: 0,
            padding: 0,
            boxShadow: 'none',
            WebkitAppearance: 'none',
            appearance: 'none',
        },
        '.swiper-pagination-clickable .swiper-pagination-bullet': {
            cursor: 'pointer',
        },
        '.swiper-pagination-bullet:only-child': {
            display: 'none !important',
        },
        '.swiper-pagination-bullet-active': {
            width: 'var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px))',
            height: 'var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px))',
            opacity: 'var(--swiper-pagination-bullet-opacity, 1)',
            background: 'var(--swiper-pagination-color, var(--swiper-theme-color))',
        },
        '.swiper-vertical > .swiper-pagination-bullets, .swiper-pagination-vertical.swiper-pagination-bullets':
            {
                right: 'var(--swiper-pagination-right, 8px)',
                left: 'var(--swiper-pagination-left, auto)',
                top: '50%',
                transform: 'translate3d(0px, -50%, 0)',
            },
        '.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet':
            {
                margin: 'var(--swiper-pagination-bullet-vertical-gap, 6px) 0',
                display: 'block',
            },
        '.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic, .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic':
            {
                top: '50%',
                transform: 'translateY(-50%)',
                width: '8px',
            },
        '.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet, .swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet':
            {
                display: 'inline-block',
                transition: '200ms transform, 200ms top',
            },
        '.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet':
            {
                margin: '0 var(--swiper-pagination-bullet-horizontal-gap, 4px)',
            },
        '.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic, .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic':
            {
                left: '50%',
                transform: 'translateX(-50%)',
                whiteSpace: 'nowrap',
            },
        '.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet':
            {
                transition: '200ms transform, 200ms left',
            },
        '.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet':
            {
                transition: '200ms transform, 200ms right',
            },
        /* Fraction */
        '.swiper-pagination-fraction': {
            color: 'var(--swiper-pagination-fraction-color, inherit)',
        },
        /* Progress */
        '.swiper-pagination-progressbar': {
            background: 'var(--swiper-pagination-progressbar-bg-color, rgba(0, 0, 0, 0.25))',
            position: 'absolute',
        },
        '.swiper-pagination-progressbar .swiper-pagination-progressbar-fill': {
            background: 'var(--swiper-pagination-color, var(--swiper-theme-color))',
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            transform: 'scale(0)',
            transformOrigin: 'left top',
        },
        '.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill': {
            transformOrigin: 'right top',
        },
        '.swiper-horizontal > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-horizontal, .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite':
            {
                width: '100%',
                height: 'var(--swiper-pagination-progressbar-size, 4px)',
                left: 0,
                top: 0,
            },
        '.swiper-vertical > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-vertical, .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite':
            {
                width: 'var(--swiper-pagination-progressbar-size, 4px)',
                height: '100%',
                left: 0,
                top: 0,
            },
        '.swiper-pagination-lock': {
            display: 'none',
        },
    },
    //* Swiper Navigation
    ':root': {'--swiper-navigation-size': '44px'},
    '.swiper-button-prev,\n.swiper-button-next': {
        position: 'absolute',
        top: 'var(--swiper-navigation-top-offset, 50%)',
        width: 'calc(var(--swiper-navigation-size) / 44 * 27)',
        height: 'var(--swiper-navigation-size)',
        marginTop: 'calc(0px - (var(--swiper-navigation-size) / 2))',
        zIndex: 10,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--swiper-navigation-color, var(--swiper-theme-color))',
    },
    '.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled': {
        opacity: 0.35,
        cursor: 'auto',
        pointerEvents: 'none',
    },
    '.swiper-button-prev.swiper-button-hidden,\n.swiper-button-next.swiper-button-hidden': {
        opacity: 0,
        cursor: 'auto',
        pointerEvents: 'none',
    },
    '.swiper-navigation-disabled .swiper-button-prev,\n.swiper-navigation-disabled .swiper-button-next':
        {
            display: 'none !important',
        },
    '.swiper-button-prev svg,\n.swiper-button-next svg': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        transformOrigin: 'center',
    },
    '.swiper-rtl .swiper-button-prev svg,\n.swiper-rtl .swiper-button-next svg': {
        transform: 'rotate(180deg)',
    },
    '.swiper-button-prev,\n.swiper-rtl .swiper-button-next': {
        left: 'var(--swiper-navigation-sides-offset, 10px)',
        right: 'auto',
    },
    '.swiper-button-next,\n.swiper-rtl .swiper-button-prev': {
        right: 'var(--swiper-navigation-sides-offset, 10px)',
        left: 'auto',
    },
    '.swiper-button-lock': {display: 'none'},
    '.swiper-button-prev:after,\n.swiper-button-next:after': {
        fontFamily: 'swiper-icons',
        fontSize: 'var(--swiper-navigation-size)',
        textTransform: 'none !important',
        letterSpacing: '0',
        fontVariant: 'initial',
        lineHeight: 1,
    },
    '.swiper-button-prev:after,\n.swiper-rtl .swiper-button-next:after': {
        content: "'prev'",
    },
    '.swiper-button-next:after,\n.swiper-rtl .swiper-button-prev:after': {
        content: "'next'",
    },
    '.swiper-zoom-container': {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    '.swiper-zoom-container > img,\n.swiper-zoom-container > svg,\n.swiper-zoom-container > canvas':
        {
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
        },
    '.swiper-slide-zoomed': {cursor: 'move', touchAction: 'none'},
}
